const en_US = {
  type: 'Datasource type',
  id: 'Datasource',
};
export default en_US;
